import { render, staticRenderFns } from "./BtnNovaSolicitacaoAditivo.vue?vue&type=template&id=3f26157b"
import script from "./BtnNovaSolicitacaoAditivo.vue?vue&type=script&lang=js"
export * from "./BtnNovaSolicitacaoAditivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports